import receiptsDialogTemplate from './receiptsDialog.html';

/*******************************************************************************
 * @ngdoc    directive
 * @restrict A
 * @name     csm.books.MakeDeposit.directive:receiptsDialog
 * @param    {Expr} entryDate    Deposit entry date.
 * @param    {Expr} selectedIDs  List of receipt items currently in deposit.
 * @param    {Expr} okAction     **Ok** button action.
 * @description
 * Undeposited receipts dialog. Reads out undeposited receipts dated up to the
 * deposit `entryDate` and displays them in a `receiptsList` component. Receipts
 * with `id` in `selectedIds` are marked as selected. `okAction` is called with
 * `$items` containing the list of selected receipts and `$totals` containing
 * `checksCount`, `totalChecks`, `totalCash`, `totalAdjust`, and `totalDeposit`.
 *******************************************************************************/
/* @ngInject */ export function receiptsDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    template: receiptsDialogTemplate,
    scope: { entryDate: '&', selectedIds: '&', okAction: '&' },
    size: 'receipts-dialog',
    preloader: preloader,
    controller: controller
  });
}

/*******************************************************************************
 * controller */
/**
 * Waits for Ok button and calls `$scope.okAction` with `$receipts` set to list
 * of selected receipts.
 *******************************************************************************/
/* @ngInject */ function controller(
  $scope,
  $timeout,
  $uibModalInstance,
  Alert
) {
  if (!$scope.receiptList.length) {
    Alert.info('No receipt valid for the deposit date.', 'No Receipts');

    $timeout(function () {
      $uibModalInstance.dismiss('cancel');
    });
    return;
  }

  /*--------------------------------------------------------*/
  /* Resolve the expressions into the property they return. */
  /*--------------------------------------------------------*/
  var $ctrl = this;
  $ctrl.entryDate = $ctrl.entryDate();
  $ctrl.selectedIds = $ctrl.selectedIds();
  $ctrl.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $ctrl.ok = function () {
    var output = {
      $items: $ctrl.itemList.getSelectedItems(),
      $totals: {
        checksCount: $ctrl.itemList.checksCount,
        totalChecks: $ctrl.itemList.totalChecks,
        totalCash: $ctrl.itemList.totalCash,
        totalAdjust: $ctrl.itemList.totalAdjust,
        totalDeposit: $ctrl.itemList.totalDeposit
      }
    };

    $ctrl.okAction(output).then(function () {
      $uibModalInstance.close();
    });
  };
}

/*******************************************************************************
 * preloader */
/**
 * Loads list of undeposited receipts up to `$scope.entryDate` from server and
 * sets `$scope.receiptList`.
 *******************************************************************************/
/* @ngInject */ function preloader(
  $scope,
  DepositsService,
  BusyScreen,
  Data,
  LocalDateSerializer,
  Alert
) {
  BusyScreen.setBusy(true);

  /*-------------------------------------------------------------*/
  /* Read out undeposited receipts up to the deposit entry date. */
  /*-------------------------------------------------------------*/
  return DepositsService.getReceiptList(
    LocalDateSerializer.serialize($scope.entryDate())
  ).then(
    function (data) {
      BusyScreen.setBusy(false);
      $scope.receiptList = data.map(function (ri) {
        return new Data.DepositReceiptItem(ri);
      });
    },
    function (error) {
      BusyScreen.setBusy(false);

      console.error(error);

      Alert.error(
        'Failed to get a list of undeposited receipts!',
        'Undeposited Receipts'
      );
      return false;
    }
  );
}
